<template>
  <v-card
    elevation="3"
    rounded="lg"
  >
    <v-toolbar
      flat
      dense
      color="color_green"
      dark
    >
      <v-toolbar-title class="text-subtitle-2">
        Calls by Service
      </v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <div
        v-if="loading"
        class="d-flex justify-center pa-6"
      >
        <v-progress-circular
          indeterminate
          color="color_green"
        />
      </div>
      <div
        v-else-if="!items.length"
        class="text-center grey--text pa-6"
      >
        No data
      </div>
      <div
        v-else
        class="chart-wrapper"
      >
        <div
          v-for="item in items"
          :key="item.service"
          class="bar-row mb-2"
        >
          <div class="bar-label text-caption">
            {{ item.service }}
          </div>
          <div class="bar-track">
            <div
              class="bar-fill"
              :style="{ width: pct(item.call_count) + '%' }"
            />
          </div>
          <div class="bar-value text-caption font-weight-bold">
            {{ item.call_count.toLocaleString('it-IT') }}
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ServiceBarChart',
  props: {
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },
  computed: {
    maxValue() {
      return this.items.length
        ? Math.max(...this.items.map(i => i.call_count))
        : 1;
    }
  },
  methods: {
    pct(value) {
      return Math.round((value / this.maxValue) * 100);
    }
  }
};
</script>

<style scoped>
.chart-wrapper { padding: 8px 0; }
.bar-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.bar-label {
  min-width: 60px;
  text-align: right;
  color: rgba(0,0,0,0.6);
}
.bar-track {
  flex: 1;
  height: 18px;
  background: rgba(0,0,0,0.06);
  border-radius: 4px;
  overflow: hidden;
}
.bar-fill {
  height: 100%;
  background: var(--v-color_green-base, #2e7d32);
  border-radius: 4px;
  transition: width 0.4s ease;
}
.bar-value {
  min-width: 60px;
}
</style>
